export function DtoDataReqLogin() {
    return {
        usuario: '',
        password: '',
        sitioUsuario: '',
        sitioPassword: '',
        ip: '',
        tokenCaptcha: '',
    };
}